module.exports = __webpack_public_path__ + "static/media/video-navidad_2020.cfb5cf53.mp4";